import { render } from "./boxes.vue?vue&type=template&id=374fc582"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/boxes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "374fc582"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('374fc582', __exports__)) {
    api.reload('374fc582', __exports__)
  }
  
  module.hot.accept("./boxes.vue?vue&type=template&id=374fc582", () => {
    api.rerender('374fc582', render)
  })

}


export default __exports__